import * as Sentry from '@sentry/react'
import type { Event, EventHint } from '@sentry/types'
import { API } from 'aws-amplify'

/**
 * Sentry beforeSend handler to filter out cancelled requests and add extra data
 */
export function handleSentryBeforeSend(
  event: Event,
  hint: EventHint
): Event | null {
  if (API.isCancel(hint?.originalException)) {
    return null
  }

  // Add version as extra data
  event.extra = {
    ...event.extra,
    appVersion: process.env.REACT_APP_VERSION,
  }

  // Strip PII from user context — keep only non-identifying correlators.
  if (event.user) {
    event.user = {
      id: event.user.id,
      ...((event.user as any).userId
        ? { userId: (event.user as any).userId }
        : {}),
    }
  }

  return event
}

// Session Replay removed for legal/privacy review (issue #358).
Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DNS,
  environment: process.env.REACT_APP_SENTRY_ENVIRONMENT,
  release: `${process.env.REACT_APP_VERSION}-${process.env.REACT_APP_SENTRY_ENVIRONMENT}`,
  enabled: (process.env.REACT_APP_SENTRY_ENVIRONMENT ?? 'local') !== 'local',
  beforeSend: handleSentryBeforeSend,
  ignoreErrors: ['Non-Error promise rejection captured'],
})
